import { twMerge } from 'tailwind-merge';

interface GlimmerProps {
  className?: string;
}

export const Glimmer = (props: GlimmerProps) => {
  return (
    <span
      className={twMerge([props.className, `absolute inset-0 overflow-hidden`])}
    >
      <span className='absolute inset-0 -translate-x-full animate-[glimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/50 to-transparent'></span>
    </span>
  );
};
